import { getGuId, getRefreshToken } from "../../utils/SecurityService.js";
import { UserLogout_api } from "../Login/LoginAPI.js";

// Ends the session: asks the backend to invalidate the refresh token, wipes all client
// storage, then replaces history so Back cannot land on a logged-in screen.
// The API error is swallowed on purpose — an expired/dead token must still log the user
// out locally, otherwise a failed call would strand them inside the app.
//
// `redirectTo` lets the caller carry context across the logout — e.g. a DeskSync desktop
// launch must land back on the login page still flagged as a desktop launch
// (`/?app=desktop&…`) so the next login can resume the handoff. Defaults to the plain
// login route, which is what the sidebar logout wants.
export const logoutUser = async (history, redirectTo = "/") => {
    try {
        const requestParams = {
            GuId: getGuId(),
            RefreshToken: getRefreshToken(),
        };
        await UserLogout_api(requestParams);
    } catch (error) {
        console.error("Logout API failed:", error);
    }

    localStorage.clear();
    sessionStorage.clear();

    // VERY important: replace history
    history.push(redirectTo, { replace: true });
};
